import { Component } from '@angular/core';
import { faCode, faLaptopCode, faFileCode, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { ThemeService } from '../../theme.service';
import { DataService } from '../../data.service';

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
    styleUrls: ['./projects.component.css'],
})
export class ProjectsComponent {
    code1 = faCode;
    code2 = faLaptopCode;
    code3 = faFileCode;
    faChevronDown = faSortDown;
    selected_filter: string;

    selected: any[];
    categories: Array<string>;
    projects: any[];
    show_list: boolean;
    dropdown_width: string;

    constructor(public dataService: DataService, private router: Router, public themeService: ThemeService) {
        this.projects = dataService.project.projects.filter((element) => !element.selected);
        this.selected = dataService.project.projects.filter((element) => element.selected);
        this.categories = dataService.project.categories;
        this.selected_filter = this.categories[0];
        this.show_list = false;
    }

    flip = () => {
        this.show_list = !this.show_list;
    };

    apply = (index) => {
        this.selected_filter = this.categories[index];
        if (this.selected_filter === 'All') {
            this.projects = this.dataService.project.projects.filter((element) => !element.selected);
            this.selected = this.dataService.project.projects.filter((element) => element.selected);
        } else {
            this.projects = this.dataService.project.projects.filter(
                (element) => !element.selected && element.category.includes(this.selected_filter)
            );
            this.selected = this.dataService.project.projects.filter(
                (element) => element.selected && element.category.includes(this.selected_filter)
            );
        }
        this.show_list = false;
    };

    open(i) {
        this.router.navigate(['projects/project', i]);
    }
}
